import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/unstake/unstake-details.module.scss';
import WithdrawalBg from '../../../../../../../assets/stake/withdrawal.svg';
import Header from '../../../../../../../components/Stake/header';
import { OM } from '../../../../../../../constants/blockchain-constants';
import UniIcon from '../../../../../../../assets/images/tokens/uni-icon.png';
import * as uniStakeActions from '../../../../../../../actions/uni-stake-actions';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import { formatToken } from '../../../../../../../helpers/token-helper';

const WithdrawDetails = () => {
  const dispatch = useDispatch();
  const colors = useGetTheme();
  const { unstakedBalance } = useSelector((state) => state.UNIstake.stake);

  return (
    <>
      <Header
        icon={UniIcon}
        title='UNI OM/ETH-Withdrawal'
        onClickBack={() => dispatch(uniStakeActions.stakeReset())}
      />
      <div className={stylesParent.cardContent} style={{ color: colors.text }}>
        <div className={styles.title}>You are Withdrawing</div>
        <div className={styles.value}>
          {formatToken(unstakedBalance)} {OM}
        </div>
        <img className={styles.image} src={WithdrawalBg} alt='' />
        <div>
          <div className={styles.descriptionItem}>
            <span>*</span> This will be withdrawn to the current connected wallet.
          </div>
        </div>
        <div className={stylesParent.cardFooterControls}>
          <Button
            onClick={() => dispatch(uniStakeActions.withdrawUnstakedSend())}
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            Withdraw
          </Button>
        </div>
      </div>
    </>
  );
};

export default WithdrawDetails;
